import { call, put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { GET_TRANSACTION_LIST_REQUEST } from '../constants/transactionConstants';
import {
  getTransactionListSuccess,
  getTransactionListFailure
} from '../actions/transactionActions';
import { getTransactionListApi } from '../api/transactionApi';

function* getTransactionListSaga(action) {
  try {
    const response = yield call(getTransactionListApi, action.payload);
    yield put(getTransactionListSuccess(response));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch transactions';
    yield put(getTransactionListFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* transactionSaga() {
  yield takeEvery(GET_TRANSACTION_LIST_REQUEST, getTransactionListSaga);
}

export default transactionSaga;